import { Modal, App } from 'antd';
import React from 'react'
import { useDelClientMutation } from '../../store/ReactWebSiteApi';

function ClientDel(props) {
    const { message } = App.useApp();
    const {confirm} = Modal; 
    const [delBusiness] = useDelClientMutation()
    return (
        <>
            {props.ec_state==='2'&& <a onClick={() => {
                            confirm({
                                title: '确定删除吗？',
                                content: props.ec_name,
                                okText: '确认',
                                okType: 'danger',
                                cancelText: '取消',
                                onOk() {
                                    delBusiness({
                                        ec_id:props.ec_id,
                                        ec_state:'2'
                                    }).then((res) => {
                                        if (res.data.Status === 'success') {
                                            message.info('删除成功！');
                                        }
                                        if (res.data.Status === "fail") {
                                            message.error('删除失败！'+res.data.Message)
                                        }
                                    })
                                },
                                onCancel() {
                                console.log('Cancel');
                                },
                            });
                        }}>删除</a> }
            {props.ec_state==='1'&&<a onClick={() => {
                                                confirm({
                                                    title: '确定取消删除吗？',
                                                    content: props.ec_name,
                                                    okText: '确认',
                                                    okType: 'danger',
                                                    cancelText: '取消',
                                                    onOk() {
                                                        delBusiness({
                                                            ec_id:props.ec_id,
                                                            ec_state:'1'
                                                        }).then((res) => {
                                                            console.log(res);
                                                            if (res.data.Status === 'success') {
                                                                message.info('取消删除成功！');
                                                            }
                                                            if (res.data.Status === "fail") {
                                                                message.error('取消删除失败！'+res.data.Message)
                                                            }
                                                        })
                                                    },
                                                    onCancel() {
                                                    console.log('Cancel');
                                                    },
                                                });
                                            }}>取消删除</a>}
        </>
    )
}

export default ClientDel